import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
//import HolidayCreatePopup from "./HolidayCreatePopup";
import ActionLink from "@mnjsplatform/components/lib/common/ActionLink";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";
import RequestDialog2 from "./RequestDialog2";
import PrintRequest from "./PrintRequest";

class HolidayList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            requestDialogVisible: false,
            requestPrintVisible: false,
            readOnly: false,
            addMode: false,
            rowKey: null,
            rowIndex: -1
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async() => {
    }

    refresh = async() => {
        await this.props.dispatch(this.props.dataListItem.execute());
    }

    createNewRequest = async() => {
        await this.props.dispatch(this.props.dataListItem.beginAdd());
        this.setState({requestDialogVisible: true, addMode: true, rowIndex: this.props.dataListItem.rowInEditIndex, rowKey: null, readOnly: false})
    }

    printRequest = async(rowKey) => {
        this.setState({requestPrintVisible: true, rowKey: rowKey})
    }

    deleteRequest = async (rowIndex) => {
        try {
            await confirm(i18next.t("VacationList_RemoveMessage", {name: this.props.dataListItem.getRow(rowIndex).AppTitle.toLowerCase()}));
            try {
                //const rowIndex = this.props.dataListItem.getRowIndex2(row);
                await this.props.dispatch(this.props.dataListItem.deleteRow(rowIndex));
            } catch (e) {
                console.error(e);
            }
        } catch (e) {
        }
    }

    selectHolidayStatement = async (row) => {
        const rowKey = this.props.dataListItem.getRowKey(row);
        const rowIndex = this.props.dataListItem.getRowIndex2(row);
        await this.props.dispatch(this.props.dataListItem.beginEdit(rowIndex));
        this.setState({
            requestDialogVisible: true,
            rowKey: rowKey,
            readOnly: !!row.DateSend,
            addMode: false,
            rowIndex: this.props.dataListItem.rowInEditIndex
        })
    }

    renderHolidayStatement = () => {
        return (<>
            <GridView dataItem={this.props.dataListItem} showHeader={false} pageSize={5} allowPagination={true}
                      readOnly={true} activePageSize={10} renderRowEx={this.renderHolidayRow} re/>
                <br/>
                <button type="button" className="btn btn-regular -goahead"
                        title={i18next.t("CreateStatement")} onClick={this.createNewRequest}>
                    {i18next.t("CreateStatement")}
                </button>
                <br/>
                {this.state.requestDialogVisible &&
                    <RequestDialog2 dataItem={this.props.dataListItem}
                                    isEkdo={this.props.isEkdo}
                                    onClose={async() => {
                                        this.setState({requestDialogVisible: false});
                                        await this.refresh();
                                    }}
                                    onPrint={this.printRequest}
                                    readOnly={this.state.readOnly}
                                    addMode={this.state.addMode}
                                    rowIndex={this.state.rowIndex}
                    />
                }
                {this.state.requestPrintVisible &&
                    <PrintRequest rowKey={this.state.rowKey}
                                  onClose={() =>
                                      this.setState({requestPrintVisible: false})
                                  }/>
                }
            </>
        );
    }

    getStatus = (row) => {
        let className = 'badge-secondary';
        switch (row.StatusIntId) {
            case 1: {
                className = 'badge-secondary';
                break;
            }
/*
            case 1: {
                className = 'badge-warning';
                break;
            }
*/
            case 2: {
                className = 'badge-success';
                break;
            }
        }
        return <span className={"badge badge-pill " + className}>{row.StatusName}</span>
    }

    renderFileName = (row) => {
        return (
            <label>
                <a href="" rel="noopener noreferrer"
                   onClick={(event) => this.getDocument(row, event)}
                   className="mr-2">&nbsp;{i18next.t("View_EDoc")}</a>
            </label>
        );
    }

    getDocument = async (row, event) => {
        event.preventDefault();
        const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "EDDocList", "DownloadDocument") + "?" + $.param({
            b_token: token,
            id: row.EDocIntId
        });
        window.open(downloadPath, '_blank');
    }

    renderHolidayRow = (rowData) => {
        return (
            <div className="col-md-8" key={rowData.rowIndex}>
                <div className="row">
                    <div className="col-md-6">
                        <ActionLink onSelect={() => {
                            this.selectHolidayStatement(rowData.row)
                        }}>
                            {rowData.row.AppTitle}
                        </ActionLink>
                    </div>
                    <div className="col-md-1 text-left">
                        {this.getStatus(rowData.row)}
                    </div>
                    <div className="col-md-1 text-center">
                        {rowData.row.IsEnableDelete === 1 &&
                            <i className="fas fa-trash-alt fa-lg" style={{color: 'red', cursor: 'pointer'}}
                               title={i18next.t('Delete')} onClick={() => this.deleteRequest(rowData.rowIndex)}/>
                        }
                    </div>
                    {rowData.row.EDocIntId && this.renderFileName(rowData.row)}
                </div>
            </div>
        )
    }

    render() {
        return this.renderHolidayStatement();
    }
}

HolidayList.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataListItem : PropTypes.object,
    IsEkdo: PropTypes.bool
}

HolidayList.defaultProps =
    {
        isEkdo: false
    };

function mapStateToProps(state) {
    return {
    }
}

export default connect(mapStateToProps)(HolidayList)